module.exports = __webpack_public_path__ + "static/img/supercleaner_banner.0fffac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supercleaner_banner.png
// module id = jt/a
// module chunks = 0